/**
 * React Query key factory — RÉGLAGES de notifications d'ENTITÉ (NOTIF-001).
 *
 * Distinct de `queryKeys.notifications` (centre d'affichage WKF-013) et de
 * `queryKeys.notificationPreferences` (préférences PERSO PREF-005). Ici : les
 * défauts d'émission par organisme (`/settings/notifications/defaults`) et le
 * catalogue d'automatisations (`/settings/notifications/automations`), scopés par
 * entité (header X-Entity-Id).
 */

const notificationSettingsAll = ['notificationSettings'] as const

export const notificationSettingsKeys = {
    notificationSettings: {
        all: notificationSettingsAll,
        /** Défauts de notification d'une entité (Onglet 1). */
        defaults: (entityId: string | null) =>
            [...notificationSettingsAll, 'defaults', entityId] as const,
        /** Catalogue des automatisations résolues d'une entité (Onglet 2). */
        automations: (entityId: string | null) =>
            [...notificationSettingsAll, 'automations', entityId] as const,
    },
}
